module.exports = __webpack_public_path__ + "img/bg.c50d9445.jpg";